import React from 'react';
import compact from 'lodash/compact';
import { useSelector } from 'react-redux';
import { Flex, Icon } from 'roo-ui/components';
import { MembershipTier, StyledText } from './primitives';
import FormatNumber from 'components/formatters/FormatNumber';
import { getTitle, getFirstName, getLastName, getMembershipTier, getPointsBalance, getIsAuthenticated } from 'store/user/userSelectors';

const AuthenticationDetails = () => {
  const title = useSelector(getTitle);
  const firstName = useSelector(getFirstName);
  const lastName = useSelector(getLastName);
  const membershipTier = useSelector(getMembershipTier);
  const pointsBalance = useSelector(getPointsBalance);
  const isAuthenticated = useSelector(getIsAuthenticated);

  if (!isAuthenticated) return null;

  return (
    <Flex alignItems="center" data-testid="auth-details-wrapper">
      <Flex flexDirection="column" color="white" justifyContent="flex-start" alignItems="flex-start" ml={2}>
        <StyledText data-hj-suppress pr={2} data-testid="member-name">
          {compact([title, firstName, lastName]).join(' ')}
        </StyledText>
        <Flex>
          <StyledText data-testid="member-points-balance">
            <FormatNumber number={pointsBalance} /> points
          </StyledText>
          <StyledText mx={1}>-</StyledText>
          <MembershipTier data-testid="member-tier">{membershipTier}</MembershipTier>
        </Flex>
      </Flex>
      <Icon name="expandMore" ml={4} />
    </Flex>
  );
};

export default AuthenticationDetails;
